import React, { useState } from 'react';
import { useStoreHistory } from '../context/StoreHistoryContext';
import './RecentSearches.css';

const RecentSearches = ({ onStoreSelect }) => {
  const { storeHistory, clearHistory } = useStoreHistory();
  const [isExpanded, setIsExpanded] = useState(false);

  if (!storeHistory.length) {
    return null;
  }

  return (
    <div className="recent-searches">
      <div 
        className="recent-header"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="header-left">
          <h3>Recent Searches</h3>
          <span className="store-count">
            {storeHistory.length} {storeHistory.length === 1 ? 'store' : 'stores'}
          </span>
        </div>
        <div className="header-right">
          <button 
            onClick={(e) => {
              e.stopPropagation();
              clearHistory();
            }} 
            className="clear-history"
          >
            <i className="fas fa-trash-alt"></i>
            Clear
          </button>
          <i className={`fas fa-chevron-${isExpanded ? 'up' : 'down'} toggle-icon`}></i>
        </div>
      </div>
      
      {isExpanded && (
        <div className="history-grid">
          {storeHistory.map((store, index) => (
            <div 
              key={store.url + index}
              className="history-item"
              onClick={() => onStoreSelect(store.url)}
            >
              <div className="store-info">
                <span className="store-domain">{new URL(store.url).hostname}</span>
                <span className="visit-count">
                  <i className="fas fa-clock"></i>
                  {store.visitCount}
                </span>
              </div>
              <div className="store-stats">
                <span className="product-stat">
                  <i className="fas fa-tag"></i>
                  {store.freeProductCount}
                </span>
                <span className="last-visit">
                  {new Date(store.lastVisited).toLocaleDateString()}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default RecentSearches; 